import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import IndentTimer from "../../indents/indent.component.timer";

interface IPrepareIndentRouteDetailHeader {
   routeDetailHeader: any;
   SelectedDate :any;
}

export const PrepareIndentRouteDetailHeader = (props: IPrepareIndentRouteDetailHeader) => {
  const { routeDetailHeader,SelectedDate } = props;
  const today = dayjs().format("DD.MM.YYYY");
  // const selectedDay = dayjs(SelectedDate, "DD.MM.YYYY").format("YYYY-MM-DD");

  const isToday = today === SelectedDate;

  console.log("route detail header:", routeDetailHeader);
  const dateTime = dayjs(new Date()).format("YYYY-MM-DD") + "T" + routeDetailHeader?.morningorderexpirytime;
  console.log("DATE",dateTime);
  console.log("selectedDate:",SelectedDate);
  
  return (
    <>
       {/* <div><IndentTimer targetTime={ new Date (dateTime)} ></IndentTimer></div> */}
       <div>
        {isToday ? (
          <IndentTimer targetTime={new Date(dateTime)} />
        ) : (
          <span style={{ fontWeight: "bold", color: "red" }}>
            நேரம் முடிந்து விட்டது
          </span>
        )}
      </div>

    <table style={{ width: "100%", backgroundColor:"#E5E4E2", borderRadius:"5px", marginBottom:"10px"}} border={0} cellPadding={15} cellSpacing={15}>
      <tr style={{ borderRadius: "5px" }}>
        <th>Route Name:</th>
        <td>{routeDetailHeader?.rname}</td>
        <th>Shift:</th>
        <td>{routeDetailHeader?.shift}</td>
        <th>Order Date:</th>
        <td>{formatDate(new Date(routeDetailHeader?.orderdate), "dd-MM-yyyy")}</td>
        <th>Active Customers:</th>
        <td>{routeDetailHeader?.activecustomer}</td>
        <th>Dispatched?:</th>
        <td>{routeDetailHeader?.isdespatched?"Yes": "No"}</td>
      </tr>
    </table>
    </>
  );
};